module.exports = __webpack_public_path__ + "img/waimapwangzhan.d621aaf2.png";